// eslint-disable-next-line import/no-cycle
import {
  TemplateParentTypeEnum,
  WidgetTypeConfig,
  ConfigurationPanelStructureItemEnum,
} from '@/types';
// eslint-disable-next-line import/no-cycle
import displayWidgetImageConfig from '@/components/template-builder/config/templates/display/widgets/widget-image-config';
// eslint-disable-next-line import/no-cycle
import getDisplayWidgetImageConfigV4 from '@/components/template-builder/config/templates/display-v4/widgets/widget-image-config';

/**
 * Remove the "Type de lien" field from a display image widget config.
 * Teaser templates don't use links on images.
 */
function removeLinkField(config: WidgetTypeConfig): WidgetTypeConfig {
  return {
    tabPanel: {
      ...config.tabPanel,
      items: (config.tabPanel?.items || []).map((item: any) => {
        if (
          item.type === ConfigurationPanelStructureItemEnum.FIELDS_GROUP
          && item.label === 'templateBuilder.configs.widgetConfiguration'
        ) {
          return {
            ...item,
            items: (item.items || []).filter(
              (field: any) => field.label !== 'templateBuilder.fields.link',
            ),
          };
        }
        return item;
      }),
    },
  };
}

export const teaserWidgetImageConfig = removeLinkField(displayWidgetImageConfig);
export const teaserWidgetImageConfigV4 = removeLinkField(getDisplayWidgetImageConfigV4(TemplateParentTypeEnum.TEASER));
